import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from '../store';

import MainLayout from '../components/Layout';
import App from '../App';
import Page from '../components/Page';
import PageMeetings from '../components/PageMeetings';
import Login from '../components/Login';
import Asset from '../components/Asset';
import Assets from '../components/Assets';
// import Prijave from '../components/Prijave';
import AssetAdd from '../components/AssetAdd';
import AssetEdit from '../components/AssetEdit';
import PageMeetingGallery from '../components/PageMeetingGallery';
import Page404 from '../components/Error404';

import data from '../data/data.json';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

class AppRouter extends React.Component {
  state = {
    navigation: data.navigation,
    footer: data.club.contact,
    onama: data.club,
    team: data.club.team,
    // membersOnly: data.membersOnly,
    vespa: data.vespa,
    crovespa2014: data.crovespa2014,
    gallery: data.meetingsGallery,
    contact: data.contact,
    join: data.join,
  };

  render() {
    return (
      <Provider store={store}>
        <Router>
          <Switch>
            <AppRoute path="/" layout={MainLayout} component={App} exact />
            <Route
              path="/klub"
              render={props => (
                <Page
                  {...props}
                  data={this.state.onama}
                  team={this.state.team}
                  navigation={this.state.navigation}
                  footer={this.state.footer}
                />
              )}
            />
            <Route
              path="/susret/:year"
              render={props => (
                <PageMeetingGallery
                  {...props}
                  data={this.state.gallery}
                  navigation={this.state.navigation}
                  footer={this.state.footer}
                />
              )}
            />
            <Route
              path="/susreti"
              render={props => (
                <PageMeetings
                  {...props}
                  data={this.state.gallery}
                  navigation={this.state.navigation}
                  footer={this.state.footer}
                />
              )}
            />

            <Route
              path="/vespa"
              render={props => (
                <Page
                  {...props}
                  data={this.state.vespa}
                  navigation={this.state.navigation}
                  footer={this.state.footer}
                />
              )}
            />

            <Route
              path="/crovespa"
              render={props => (
                <Page
                  {...props}
                  data={this.state.crovespa2014}
                  navigation={this.state.navigation}
                  footer={this.state.footer}
                />
              )}
            />

            <Route
              path="/prijava"
              render={props => (
                <Page {...props} data={this.state.join} navigation={this.state.navigation} footer={this.state.footer} />
              )}
            />

            <Route
              path="/kontakt"
              render={props => (
                <Page
                  {...props}
                  data={this.state.contact}
                  navigation={this.state.navigation}
                  footer={this.state.footer}
                />
              )}
            />

            <AppRoute exact path="/assets/add" layout={MainLayout} component={AssetAdd} />
            <AppRoute exact path="/asset/:id" layout={MainLayout} component={Asset} />
            <AppRoute exact path="/asset/edit/:id" layout={MainLayout} component={AssetEdit} />
            <AppRoute exact path="/login" layout={MainLayout} component={Login} />
            <AppRoute exact path="/members" layout={MainLayout} component={Assets} />
            {/* <AppRoute exact path="/prijave-x-susret" layout={MainLayout} component={Prijave} /> */}
            <AppRoute layout={MainLayout} component={Page404} />
          </Switch>
        </Router>
      </Provider>
    );
  }
}
export default AppRouter;



// WEBPACK FOOTER //
// ./src/routes/index.js